import axios from 'axios';

export const defaultState = {
  dlqs: [],
};

export const mutations = {
  SET_STRATEGIES_DLQ_DATA(dlqState, data) {
    dlqState.dlqs = data;
  },
};

export const getters = {
  getStrategiesDlqs: contractState => contractState.dlqs,
};

export const actions = {
  fetchStrategiesDLQs({ commit }) {
    return axios.get(`${window.BASE_API.STRATEGIES_SETTLEMENT}/dlqs`)
      .then(({ data }) => {
        commit('SET_STRATEGIES_DLQ_DATA', data);

        return data;
      })
      .catch((error) => {
        commit('SET_STRATEGIES_DLQ_DATA', []);

        return Promise.reject(error);
      });
  },
};

const strategiesDLQ = {
  state: defaultState,
  mutations,
  getters,
  actions,
};

export default strategiesDLQ;



// WEBPACK FOOTER //
// ./src/store/digitalDepots/strategiesDLQ.js